// extracted by mini-css-extract-plugin
export default {"zoomModal":"s3-z"};